module.exports = __webpack_public_path__ + "img/1.d99fc611.png";